import { render, staticRenderFns } from "./SupportingDocument.vue?vue&type=template&id=1f75767c&scoped=true&"
import script from "./SupportingDocument.vue?vue&type=script&lang=js&"
export * from "./SupportingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75767c",
  null
  
)

export default component.exports